import polyglotI18nProvider from "ra-i18n-polyglot";
import portugueseMessages from "../../../i18n/portugueseMessages";

// App is Portuguese-only. Keeping a single locale avoids navigator.language
// detection races and prevents Chrome from offering auto-translation
// (which breaks React reconciliation and causes removeChild errors).
export const i18nProvider = polyglotI18nProvider(
  () => portugueseMessages,
  "pt",
  [{ locale: "pt", name: "Português" }],
  { allowMissing: true },
);
